import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

export function PlayTestPanel() {
  const [active, setActive] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/admin/play-test").then((r) => setActive(!!r.data.active)).catch(() => setActive(false)); }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      const next = !active;
      const r = await api.post("/admin/play-test", { active: next });
      setActive(!!r.data.active);
      toast.success(next ? "Play Test mode enabled" : "Play Test mode disabled");
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="play-test-panel" className={`mb-6 border p-4 rounded-sm ${active ? "border-sky-500/60 bg-sky-950/20" : "border-amber-900/30 bg-zinc-950"}`}>
      <div className="flex items-center gap-2 mb-3">
        <FlaskConical size={16} className={active ? "text-sky-400" : "text-zinc-400"} />
        <h3 className="font-cinzel text-amber-300 uppercase tracking-widest text-sm">Play Test Event</h3>
        {active && <span data-testid="play-test-active-badge" className="ml-auto text-xs text-sky-300 font-semibold uppercase tracking-wide">Live</span>}
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <p className="text-sm text-zinc-500 flex-1 min-w-[200px]">
          Shows a "game in testing" banner on the Ludus page and a VIP-is-live notice on the VIP page for all players.
        </p>
        <button data-testid="play-test-toggle-btn" onClick={toggle} disabled={active === null || busy}
          className={`px-5 py-2 font-cinzel uppercase tracking-wide text-sm rounded-sm disabled:opacity-50 ${active ? "border border-red-900/50 text-red-300 hover:border-red-500" : "bg-sky-500 text-zinc-950 hover:bg-sky-400"}`}>
          {active ? "Turn Off" : "Turn On"}
        </button>
      </div>
    </div>
  );
}
